import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4 gap-4 lg:gap-6 px-4" }
const _hoisted_2 = { class: "col-span-4 md:col-span-2" }
const _hoisted_3 = { class: "col-span-4 md:col-span-2 row-span-2" }
const _hoisted_4 = { class: "col-span-2 md:col-span-1" }
const _hoisted_5 = { class: "col-span-2 md:col-span-1" }
const _hoisted_6 = {
  key: 0,
  class: "col-span-4 md:col-span-2"
}
const _hoisted_7 = { class: "col-span-2 md:col-span-1 flex items-end" }
const _hoisted_8 = { class: "col-span-2 md:col-span-1 flex items-end" }

import ChangeEmailForm from './ChangeEmailForm.vue'
	import ChangePasswordForm from './ChangePasswordForm.vue'

	// languages
	import { 
		useI18n
	} from 'vue-i18n'

	// store
	import { 
		localesStore as _localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	// types
	import { 
		Notification
	} from '@/types'

	// vue
	import {
		ref, 
		computed
	} from 'vue'

	
	const __default__ = { name: 'AccountDetails' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		contact: {
			type: Object,
			default: () => {return {}}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {

	// components
	const props = __props
	
	const localesStore = _localesStore()
	const userStore = _userStore()

	const {t} = useI18n()

	const showNotification = ref(false)
	const notificationIcon = ref(0)
	const notificationTitle = ref('')
	const notificationSubtitle = ref('')
	
	function displayNotification(notification: Notification) {
		notificationIcon.value = notification.icon
		notificationTitle.value = notification.title
		notificationSubtitle.value = notification.subtitle
		changeEmailModal.value.open = false
		changePasswordModal.value.open = false
		showNotification.value = true
	}
	
	const address = computed(() => {		
		return props.contact?.fieldData?.address_full_display_form?.replaceAll("\r", "\n")
	})

	const changeEmailModal = ref<{open: boolean}>({open: false})
	const changePasswordModal = ref<{open: boolean}>({open: false})

	function openChangeEmailModal() {
		changeEmailModal.value.open = true
	}
	
	function openChangePasswordModal() {
		changePasswordModal.value.open = true
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_notification = _resolveComponent("tw-notification")!
  const _component_data_display = _resolveComponent("data-display")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showNotification.value)
      ? (_openBlock(), _createBlock(_component_tw_notification, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showNotification.value = false)),
          title: notificationTitle.value,
          subtitle: notificationSubtitle.value,
          duration: 8000,
          icon: notificationIcon.value
        }, null, 8, ["title", "subtitle", "icon"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_unref(userStore).getContactType == 'Staff')
          ? (_openBlock(), _createBlock(_component_data_display, {
              key: 0,
              label: _unref(localesStore).getLabel('10'),
              value: __props.contact?.fieldData?.name_nick_display || '-' ,
              loading: __props.loading
            }, null, 8, ["label", "value", "loading"]))
          : (_openBlock(), _createBlock(_component_data_display, {
              key: 1,
              label: _unref(localesStore).getLabel('11'),
              value: __props.contact?.fieldData?.category_display || '-' ,
              loading: __props.loading
            }, null, 8, ["label", "value", "loading"]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_data_display, {
          label: _unref(localesStore).getLabel('194'),
          "value-class": "whitespace-pre-line",
          value: address.value || '-' ,
          loading: __props.loading
        }, null, 8, ["label", "value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_data_display, {
          label: _unref(localesStore).getLabel('7'),
          value: __props.contact?.fieldData?.['contact__COUNTRIES__countryID::name_display'] || '-' ,
          loading: __props.loading
        }, null, 8, ["label", "value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_data_display, {
          label: _unref(localesStore).getLabel('17'),
          value: __props.contact?.fieldData?.['contact__AREAS_COUNTRIES__areaCountryID::area_display'] || '-' ,
          loading: __props.loading
        }, null, 8, ["label", "value", "loading"])
      ]),
      (_unref(userStore).getContactType == 'Staff')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_data_display, {
              label: _unref(localesStore).getLabel('110'),
              value: __props.contact?.fieldData?.['contacts__USER__contactID::email'] || '-' ,
              loading: __props.loading
            }, null, 8, ["label", "value", "loading"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("button", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openChangeEmailModal()))
        }, _toDisplayString(_unref(t)('changeEmail.title')), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "link",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (openChangePasswordModal()))
        }, _toDisplayString(_unref(t)('changePassword.title')), 1)
      ]),
      _createVNode(_component_tw_modal, {
        title: _unref(t)('changeEmail.title'),
        breadcrumb: [],
        "modal-max-width": "max-w-md",
        "modal-min-height": "min-h-0",
        ref_key: "changeEmailModal",
        ref: changeEmailModal
      }, {
        default: _withCtx(() => [
          _createVNode(ChangeEmailForm, {
            onCloseEmailModal: _cache[3] || (_cache[3] = (notification) => {displayNotification(notification)})
          })
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(_component_tw_modal, {
        title: _unref(t)('changePassword.title'),
        breadcrumb: [],
        "modal-max-width": "max-w-md",
        "modal-min-height": "min-h-0",
        ref_key: "changePasswordModal",
        ref: changePasswordModal
      }, {
        default: _withCtx(() => [
          _createVNode(ChangePasswordForm, {
            onClosePasswordModal: _cache[4] || (_cache[4] = (notification) => {displayNotification(notification)})
          })
        ]),
        _: 1
      }, 8, ["title"])
    ])
  ], 64))
}
}

})